import { render, staticRenderFns } from "./Telemetria.vue?vue&type=template&id=7045f0ea&"
import script from "./Telemetria.vue?vue&type=script&lang=js&"
export * from "./Telemetria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports